<ng-container *ngComponentOutlet="component; inputs: componentInputs"></ng-container>
